<template>
 <div class="exclusive-finish">
    <img :src="tipImage" />
    <p class="big-text">专属价格已失效</p>
    <p>专属价格已过期或已被使用</p>
    <button @click="back">返回</button>
  </div>
</template>

<script>
export default {
  name: 'exclusiveFinish',
  data() {
    return {
      tipImage: `${this.$cdnImageUrl}/goods/tipImg.png`,
    }
  },
  methods: {
    back() {
      if (this.$util.isShopKeeper()) {
        this.$util.openNewWindow('https://mall.haier.com/mallapp/home/index.html?close_current_page=true', true, true)
      } else {
        this.$store.dispatch('doHistoryBack')
      }
    },
  },
}
</script>

<style scoped>
.exclusive-finish {
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 9999; /* 放在最上层 */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  background-color: #fff;
}
.exclusive-finish img {
  width: 2.4rem;
  height: 2.4rem;
}
.exclusive-finish p {
  color: #999;
  font-size: 0.24rem;
  line-height: 0.28rem;
}
.exclusive-finish .big-text {
  margin: 0.4rem 0 0.24rem;
  font-size: 0.32rem;
}
.exclusive-finish button {
  width: 1.76rem;
  height: 0.72rem;
  border-radius: 0.36rem;
  background: #2878ff;
  color: #fff;
  margin-top: 0.96rem;
  border: 0;
  outline: 0;
}
</style>
